import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { DashboardFilterBar } from '@/features/dashboard-filters';
import { useHeaderFilters } from '@/features/header-filters';

import { useStorageOverview } from '../lib/use-storage-overview';
import { StorageOverviewPage } from './storage-overview-page';

/**
 * Hands the storage filters to the shared header panel, the way the map and every
 * other filterable page does, leaving the page to its tabs and charts. Filters
 * apply as they change, so the panel's Apply only closes it.
 */
export function StorageOverviewWithFilters() {
  const { t } = useTranslation();
  const { setFilterConfig } = useHeaderFilters();
  const storage = useStorageOverview();

  const {
    urlState,
    locationsData,
    selectedLocations,
    setSelectedLocations,
    locationsLoading,
    updateOption,
    handleDateRangeChange,
    showDateRange,
    activeFilters,
    activeFiltersCount,
    hasActiveFilters,
    resetFilters,
    projectId,
    siteId
  } = storage;

  useEffect(() => {
    setFilterConfig({
      id: 'storage-overview-filters',
      title: t('report.storageOverview.title', 'Storage Overview'),
      content: (
        <DashboardFilterBar
          variant="storage"
          options={urlState}
          onOptionChange={updateOption}
          locationGroups={locationsData?.locationGroups}
          selectedLocations={selectedLocations}
          onLocationsChange={setSelectedLocations}
          locationsLoading={locationsLoading}
          onDateRangeChange={handleDateRangeChange}
          showDateRange={showDateRange}
          resetKey={`${projectId}-${siteId}`}
        />
      ),
      activeCount: activeFiltersCount,
      activeFilters,
      onReset: resetFilters,
      onClearAll: resetFilters,
      isResetDisabled: !hasActiveFilters
    });
  }, [
    urlState,
    locationsData,
    selectedLocations,
    setSelectedLocations,
    locationsLoading,
    updateOption,
    handleDateRangeChange,
    showDateRange,
    activeFilters,
    activeFiltersCount,
    hasActiveFilters,
    resetFilters,
    projectId,
    siteId,
    setFilterConfig,
    t
  ]);

  return <StorageOverviewPage storage={storage} />;
}
